import React, { useContext, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useWarehouseOrderStorageService from '../../../app/services/hooks/useWareHouseOrderStorageService';
import { WarehouseOrderStorageShowDataForm } from '../../../app/models/WareHouseOrderStorage';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import WarehouseQuoteStorageShowForm from '../../Quotes/subpages/WareHouseQuote/components/forms/WareHouseStorageForms/WareHouseStorageShowForm';
import LazyLoading from '../../../components/LazyLoading';

interface Props {
    storageId: number;
    onSaved?: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseOrderStorageShow = ({
    storageId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {showWarehouseOrderStorage, fetchingShowWarehouseOrderStorage} =
        useWarehouseOrderStorageService();

    const [showStorage, setShowStorage] = useState<WarehouseOrderStorageShowDataForm>({});

    useEffect(() => {
        show();
    }, [storageId]);

    const show = () => {
        showWarehouseOrderStorage(storageId, {
                onSuccess: (response: ServiceResponse) => {
                    setShowStorage(response.data.storage);
                },
        });
    };

    return (

        <>
            {!fetchingShowWarehouseOrderStorage ? (
                <>
                    <WarehouseQuoteStorageShowForm
                        storageform={showStorage}
                    />
                </>
            ) : (
                <LazyLoading />
            )}
        </>
    );
};

export default WarehouseOrderStorageShow;
